import { useEffect, useMemo,useState } from 'react';

import { useLayout } from '@/components/datamodel/hooks/useLayout';
import { logger } from '@/services/logger';
import { PersistedItem } from '@/types/DataModel';

/**
 * @returns the item hierarchy name
 */
const useItemHierarchyName = (item: PersistedItem) => {

    const { layout } = useLayout();
    const [itemHierarchyName, setItemHierarchyName] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    // Memoize the hierarchy navigation to prevent unnecessary recalculations
    const hierarchyNavigation = useMemo(() => {
        return layout?.layoutOptions?.hierarchyNavigation;
    }, [layout?.layoutOptions?.hierarchyNavigation]);

    useEffect(() => {
        setIsLoading(true);

        // Prepare item hierarchies
        if (!item) {
            // We are creating a new item, we don't show any hierarchies
            setItemHierarchyName(undefined);
            setIsLoading(false);
            return;
        }

        if (!hierarchyNavigation) {
            logger.error('ItemEditorDialog: Item has no hierarchyNavigation info', { item, layout });
            setItemHierarchyName(undefined);
            setIsLoading(false);
            return;
        }

        if (!hierarchyNavigation.hierarchy_name) {
            logger.error('ItemEditorDialog: Could not find hierarchy name', {
                item,
                category: item.category__,
                hierarchyNavigation
            });
            setItemHierarchyName(undefined);
            setIsLoading(false);
            return;
        }

        setItemHierarchyName(hierarchyNavigation.hierarchy_name);
        setIsLoading(false);

    }, [item, hierarchyNavigation]);

    return {
        itemHierarchyName,
        isLoading,
    };

};

export { useItemHierarchyName };
